import * as e from "react";
function d({
  controlled: t,
  default: u,
  name: c,
  state: f = "value"
}) {
  const {
    current: a
  } = e.useRef(t !== void 0), [n, s] = e.useState(u), l = a ? t : n, o = e.useCallback((r) => {
    a || s(r);
  }, []);
  return [l, o];
}
export {
  d as u
};
//# sourceMappingURL=useControlled-ZIJRsfP8.mjs.map
